<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ this.$l('v_scm_images_title') || '工厂及产品图片' }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-panel role="button" style="color: #606266">
            <i v-if="isShowPanel" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowPanel" id="collapse-panel">
        <div class="mt-2" v-if="tableData">
          <swiper :options="swiperOptionTop">
            <swiper-slide
              v-for="(itemImage, index) in filterImage(tableData)"
              :key="index"
            >
              <div class="swiper-zoom-container">
                <img
                  :src="itemImage.scmImageUrl"
                  @click="imageView(index, filterImage(tableData))"
                />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev">
              <i class="fa fa-chevron-circle-left icon-font" />
            </div>
            <div class="swiper-button-next" slot="button-next">
              <i class="fa fa-chevron-circle-right icon-font" />
            </div>
          </swiper>
        </div>
        <!-- <div class="image-box">
          <img
            v-for="(item, index) in tableData"
            :key="index"
            @click="imageView(index, tableData)"
            :src="item.scmImageUrl"
            class="image"
          />
          <p v-if="isNoData" class="p-style">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div> -->
        <div v-show="false" ref="viewBigScmImage" v-viewer="{ movable: true }">
          <img
            v-for="(item, index) in viewerImageList"
            :src="item.scmImageUrl"
            :key="index"
          />
        </div>
      </b-collapse>
    </el-card>
    <el-card class="mt-2">
      <file :params="params" />
    </el-card>
  </div>
</template>
<script>
import File from './file'
export default {
  components: { File },
  props: {
    params: {
      default: null,
      type: Object
    }
  },
  watch: {
    params: {
      handler() {
        if (this.params.scmCode) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isShowPanel: true,
      isBusy: false,
      defaultImageUrl: '',
      isNoData: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      tableData: [],
      viewerImageList: []
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   const swiperTop = this.$refs.swiperTop.$swiper;
    //   const swiperThumbs = this.$refs.swiperThumbs.$swiper;
    //   swiperTop.controller.control = swiperThumbs;
    //   swiperThumbs.controller.control = swiperTop;
    // });
  },
  beforeDestroy() {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .scmInfoImageListApi(params)
        .then((res) => {
          this.isBusy = false
          let data = this.filterImage(res.body.data)
          this.tableData = data
          // console.log(JSON.stringify(this.tableData));
          if (!this.tableData.length > 0) {
            this.isNoData = true
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    // 点击大图显示图片预览组件
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const tempViewer = this.$refs.viewBigScmImage.$viewer
        this.viewerImageList = imageList
        tempViewer.view(index)
        tempViewer.show()
      }
    },
    //过滤图片数据
    filterImage(data) {
      const filter = ['jpeg', 'png', 'jpg', 'gif']
      return data.filter((item) => {
        return filter.includes(
          item.scmImageCode.substring(item.scmImageCode.indexOf('.') + 1)
        )
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-slide {
  height: 308px;
}
.swiper-button-next {
  right: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.swiper-button-prev {
  left: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}
.icon-font {
  font-size: 2.2rem;
}
.image-box {
  // display: flex;
  flex-wrap: wrap;
  height: 315px;
  overflow-x: hidden;
}
.image-box .image {
  width: 150px;
  height: 130px;
  object-fit: contain;
  margin-right: 10px;
}
.p-style {
  width: 100%;
  text-align: center;
  line-height: 280px;
}
</style>
